import React from "react";
import HeroImg from "../components/HeroImg";
import Navbar from "../components/Navbar";
import Work from "../components/Work";
import Footer from "../components/Footer";




const Home = () => {
    
  return <div>
    <Navbar />
    <HeroImg />
    <Work />
    <Footer />
  </div>
};

export default Home;
